import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import alloyReducer from './slices/alloy';
import authReducer from './slices/auth';
import blosterReducer from './slices/bolster';
import bundleoutwardReducer from './slices/bundleoutward';
import conversionRateReducer from './slices/conversion-rate';
import customerReducer from './slices/customer';
import customerTypeReducer from './slices/customer-type';
import dieCategoryReducer from './slices/die-category';
import dieGroupReducer from './slices/die-group';
import diePressReducer from './slices/die-press';
import dieProfileReducer from './slices/die-profile';
import dieQuatationReducer from './slices/die-quotation';
import dieSizeReducer from './slices/die-size';
import PlanningReducer from './slices/Planning';
import dieSubCategoryReducer from './slices/die-subcategory';
import dieToolReducer from './slices/die-tool';
import transporterReducer from './slices/transporter';
import dieTypeReducer from './slices/die-type';
import excessStockReducer from './slices/excess-stock';
import messageReducer from './slices/message';
import nalcoRateReducer from './slices/nalco-rate';
import profileQuotationReducer from './slices/profile-quotation';
import proformaReducer from './slices/proforma';
import quotationReducer from './slices/quotation';
import temperlistReducer from './slices/tempers';
import userReducer from './slices/user';
import userGroupReducer from './slices/user-group';
import userPermissionReducer from './slices/user-permission';
import vendorReducer from './slices/vendor';
import workOrderReducer from './slices/work-order';
import bundleInWardReducer from './slices/bundleinword';
import currentStockReducer from './slices/current-stock';
import warehouseReducer from './slices/warehouse';
import warehouseBundleOutwardReducer from './slices/warehouse-bundle-outward';
import stockverifyReducer from './slices/stock-verify';
import dispatchverifyReducer from './slices/dispatch-verification';
import dashboardReducer from './slices/dashboard';
import productionReducer from './slices/production';
import reportService from './slices/report';
import ipReducer from './slices/ipSlice';
import activityReducer from './slices/activity-log'
import inquiryReducer from './slices/inquiry';
import inquiryQuotationReducer from './slices/inquiry-quotation';
import salesOrderReducer from './slices/sales-order';
import jobWorkReducer from './slices/job-work';
import financialYearReducer from './slices/financial-year';
import packingModeReducer from './slices/packing';
import shiftReducer from './slices/shift';
import settingReducer from './slices/setting';
import vehicleTypeReducer from './slices/vehicle-type';
import vehicleReducer from './slices/vehicle';
import materialReducer from './slices/material';
import purchaserReducer from './slices/purchaser';
import sellerReducer from './slices/seller';
import firstWeightEntryReducer from './slices/first-weight-entry';
import secondWeightEntryReducer from './slices/second-weight-entry';
import manualWeightEntryReducer from './slices/manual-weight-entry';


const reducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  dieGroup: dieGroupReducer,
  dieProfile: dieProfileReducer,
  dieTool: dieToolReducer,
  transporter: transporterReducer,
  diesize: dieSizeReducer,
  dieType: dieTypeReducer,
  diePress: diePressReducer,
  message: messageReducer,
  dieCategory: dieCategoryReducer,
  dieSubCategory: dieSubCategoryReducer,
  customer: customerReducer,
  userGroup: userGroupReducer,
  userPermission: userPermissionReducer,
  alloy: alloyReducer,
  temper: temperlistReducer,
  vendor: vendorReducer,
  bloster: blosterReducer,
  customerType: customerTypeReducer,
  conversionRate: conversionRateReducer,
  nalcoRate: nalcoRateReducer,
  profileQuotation: profileQuotationReducer,
  dieQuotation: dieQuatationReducer,
  quotation: quotationReducer,
  workOrder: workOrderReducer,
  proforma: proformaReducer,
  bundleoutward: bundleoutwardReducer,
  excessStock: excessStockReducer,
  bundleInWard: bundleInWardReducer,
  Planning: PlanningReducer,
  currentStock: currentStockReducer,
  warehouse: warehouseReducer,
  warehouseBundleOutward: warehouseBundleOutwardReducer,
  stockverify: stockverifyReducer,
  dispatchVerification: dispatchverifyReducer,
  dashboard: dashboardReducer,
  production: productionReducer,
  report: reportService,
  vehicleType: vehicleTypeReducer,
  vehicle: vehicleReducer,
  material: materialReducer,
  purchaser: purchaserReducer,
  seller: sellerReducer,
  firstWeightEntry: firstWeightEntryReducer,
  secondWeightEntry: secondWeightEntryReducer,
  manualWeightEntry: manualWeightEntryReducer,
  ip: ipReducer,
  activityLog: activityReducer,
  jobWork: jobWorkReducer,
  inquiry: inquiryReducer,
  inquiryQuotation: inquiryQuotationReducer,
  salesOrder: salesOrderReducer,
  financialYear: financialYearReducer,
  packingMode: packingModeReducer,
  setting: settingReducer,
  shift: shiftReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'setting'], // persist only needed slices
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer, // ✅ IMPORTANT FIX
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // ✅ required for redux-persist
    }),
});

export const persistor = persistStore(store);

